import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as Sentry from "@sentry/react";
import { getImportMetaEnv } from "./utils/common";
import { getLaunchDarklyKey } from "./constants/global";
import { asyncWithLDProvider } from "launchdarkly-react-client-sdk";

const DEFAULT_SENTRY_TRACES_SAMPLE_RATE = 0.01;
const sentryTracesSampleRateSetting = getImportMetaEnv(
  'VITE_APP_SENTRY_TRACES_SAMPLE_RATE'
);
const configuredSentryTracesSampleRate = sentryTracesSampleRateSetting?.trim()
  ? Number(sentryTracesSampleRateSetting)
  : Number.NaN;
const sentryTracesSampleRate =
  configuredSentryTracesSampleRate >= 0 && configuredSentryTracesSampleRate <= 1
    ? configuredSentryTracesSampleRate
    : DEFAULT_SENTRY_TRACES_SAMPLE_RATE;

if (process.env.REACT_APP_DEPLOY_ENV === 'prod' && getImportMetaEnv('VITE_APP_SENTRY_DSN')) {
  Sentry.init({
    dsn: getImportMetaEnv('VITE_APP_SENTRY_DSN'),
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    normalizeDepth: 10,
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    // Tracing
    tracesSampleRate: sentryTracesSampleRate,
    // Session Replay is disabled across all environments (PRF-1301).
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    environment: window.location.hostname,
  });
}

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element #root not found');
}

const root = ReactDOM.createRoot(container);

// Initialize LaunchDarkly with anonymous context
// Context will be updated to organization context after user authentication in App.tsx
(async () => {
  try {
    const ldClientId = getLaunchDarklyKey();
    // Only initialize LaunchDarkly if we have a valid client ID
    if (ldClientId && ldClientId !== "undefined") {
      const LDProvider = await asyncWithLDProvider({
        clientSideID: ldClientId,
      });
      root.render(
        <LDProvider>
          <App />
        </LDProvider>
      );
    } else {
      // If no LaunchDarkly key, render without provider
      console.warn(
        "LaunchDarkly client ID not configured, feature flags will not be available"
      );
      root.render(<App />);
    }
  } catch (error) {
    console.error("Error initializing LaunchDarkly:", error);
    root.render(<App />);
  }
})();

reportWebVitals();
